Namespace 'Monitoring.Models.SocialContents'

class Monitoring.Models.SocialContents.InstagramBusinessDiscoveryListeningContent
  constructor: (media, author) ->
    @media = media
    @author = author

  getJson: ->
    {
      mainText: @getMainText(),
      createdAt: @getCreatedAt(),
      contentID: @getCondition(),
      isBrandContent: @getIsBrandContent(),
      subType: @getSubType()
    }

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    false

  getGroupType: ->
    'instagramapi'

  getSubType: ->
    sub_type = @media.getSubType?()
    sub_type = 'instagram_business_discovery_listening_media' unless sub_type
    sub_type

  getType: ->
    'instagram'

  getOrigin:->
    origin = @media.getOrigin?()
    origin = 'instagram_business_discovery_api' unless origin
    origin

  getPrivacy: ->
    'public'

  getAuthor: ->
    @author

  getAvatar: ->
    @author.getProfilePictureUrl()

  getAuthorId: ->
    @author.getId()

  getAuthorName: ->
    @author.getName()

  getAuthorUsername: ->
    @author.getUsername()

  getMainText: ->
    @media.getText()

  getCreatedAt: ->
    @media.getCreatedAt()

  getParentId: ->
    @media.getParentId()

  getContentId: ->
    @media.getContentId()

  isBrandContent: ->
    @media.getIsBrandContent()

  getPermalink: ->
    @media.getPermalink()

  contentUrl: ->
    @getPermalink()

  getMediaType: ->
    @media.getMediaType()

  getMediaUrl: ->
    @media.getMediaUrl()

  imageUrl: ->
    @getMediaUrl() unless @_isMediaVideo()

  videoUrl: ->
    @getMediaUrl() if @_isMediaVideo()

  _isMediaVideo: ->
    @getMediaType() == "VIDEO"

  hasAttachments: ->
    false

  getAttachments: ->
    []

  hasShares: ->
    false

  isListeningOnly: ->
    true
